import {useEffect, useState, useCallback} from 'react';
import {Outlet, useParams, useNavigate} from 'react-router-dom';
// @mui
import { Box, DialogContent } from '@mui/material';
// hooks
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import NotificaAudio from 'src/sections/@dashboard/Notificacoes/ComponetesNotificacoes/NotificaAudio';
import NotificaVideo from 'src/sections/@dashboard/Notificacoes/ComponetesNotificacoes/NotificaVideo';
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import {useAuthContext} from "../../auth/useAuthContext";
import Notificacoes from "../../sections/@dashboard/Notificacoes/Notificacoes";
import ChamadaRecusadaDialog from "../../sections/@dashboard/Notificacoes/ComponetesNotificacoes/ChamadaRecusadaDialog";
import ChamadaEncerradaDialog
    from "../../sections/@dashboard/Notificacoes/ComponetesNotificacoes/ChamadaEncerradaDialog";
import ContributionTopbar from './contribution-topbar/ContributionTopbar';
import { useSnackbar } from '../../components/snackbar';
import ToastNovaMensagem from '../../sections/@dashboard/chat/ToastNovaMensagem';
import { PATH_DASHBOARD } from '../../routes/paths';






// ----------------------------------------------------------------------
type props = {
    socket: any;
};
export default function DashboardLayout({socket}:props) {

  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  // --------------------------------------------------------------------
  // Mensagem chegando enquanto a pessoa esta em OUTRA tela.
  // Mostra um toast com o nome de quem enviou; clicar abre a conversa.
  // Some sozinho em 1 minuto.
  // --------------------------------------------------------------------
  const aoChegarMensagemFora = useCallback((dados: any) => {
      if (!dados || !dados.IDAtendimento) return;

      // ja estou nessa conversa: nao precisa de aviso
      if (window.location.hash.indexOf(dados.IDAtendimento) >= 0) return;

      const chave = `nova-${dados.messageId}`;

      enqueueSnackbar('', {
          key: chave,
          autoHideDuration: 60000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          content: () => (
              <ToastNovaMensagem
                  nome={dados.nome}
                  avatar={dados.avatar}
                  resumo={dados.message}
                  onAbrir={() => {
                      closeSnackbar(chave);
                      navigate(PATH_DASHBOARD.chat.view(dados.IDAtendimento));
                  }}
                  onFechar={() => closeSnackbar(chave)}
              />
          ),
      });
  }, [enqueueSnackbar, closeSnackbar, navigate]);

  useEffect(() => {
      socket.on('novamensagem', aoChegarMensagemFora);

      return () => {
          socket.off('novamensagem', aoChegarMensagemFora);
      };
  }, [socket, aoChegarMensagemFora]);

  const { themeLayout } = useSettingsContext();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);
  const [openmodal, setopenmodal] = useState(false);

  const [openmodalChamadas, setopenmodalChamadas] = useState(false);
  const [contributionOffset, setContributionOffset] = useState(0);

  const [open2, setOpen2] = useState<any>('');
  const [Dadosnoti, setDadosnoti] = useState<any>('');
    const { user } = useAuthContext();
  const isNavHorizontal = themeLayout === 'horizontal';
    const {tokenConversa = ''} = useParams();
  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };


    useEffect(() => {
        const url = new URL(window.location.href);
        url.searchParams.delete("code");
        url.searchParams.delete("scope");
        url.searchParams.delete("authuser");
        url.searchParams.delete("prompt");
        window.history.pushState('object or string', 'Title', url);

        const salaUsuario = user?.id ? `atendido${user.id}` : '';
        if (!salaUsuario) return undefined;

        const entrarNaSalaPessoal = () => {
            socket.emit('entrarusuario', salaUsuario);
        };

        entrarNaSalaPessoal();
        socket.on("connect", entrarNaSalaPessoal);

        return () => {
            socket.off("connect", entrarNaSalaPessoal);
            if (socket.connected) {
                socket.emit('sairusuario', salaUsuario);
            }
        };
    }, [socket, user?.id]);

    useEffect(() => {

        let timer:any;

        socket.on("notifica", async (dados:any)  => {

        if(dados.tipo === "notificaaudio" || dados.tipo === "notificavideo"){
            setopenmodalChamadas(true);
        }else{
            setopenmodal(true);
        }

            setOpen2(dados.tipo);
            setDadosnoti(dados);



        });

    },[open2, socket, user]);


    console.log( open2);
    console.log( Dadosnoti);
    console.log( open2 === "notificavideo");


  const handleClose = () => {
    setOpen(false);
  };

  const fecharmodal = () => {
    setOpen2('');
    setopenmodal(false);
    setopenmodalChamadas(false);
  };


  const [tipoDialogChamada, setTipoDialogChamada] = React.useState('');

  const [openDialogChamada, setOpenDialogChamada] = React.useState(true);

  const handleClickOpenDialogChamada = () => {
    setOpenDialogChamada(true);
  };

  const handleCloseDialogChamada = () => {
    setOpenDialogChamada(false);
  };




    // notificaaudio
    // notificavideo

    const tipo = (
        <>



            { openmodal  ?
                (
                    <Dialog
                        fullScreen
                        scroll='body'
                        open
                    ><Notificacoes fecharmodal={fecharmodal} dados={Dadosnoti} estadoNotifica={open2}/>
                    </Dialog>
                ) : ('')
            }
        </>
    );


    const dialogChamada = (
      <>
        
                  <Dialog
                    open={openmodalChamadas}
                    scroll='body'
                    className='DialogAudioEVideo'
                  >
                      { open2 === "notificaaudio" && Dadosnoti.tipochamada === 'recebida' ? (
                            <NotificaAudio socket={socket}  fecharmodal={fecharmodal} dados={Dadosnoti}  />
                      ) : ''}

                      { open2 === "notificaaudio" && Dadosnoti.tipochamada === 'recusada' ? (
                            <ChamadaRecusadaDialog  fecharmodal={fecharmodal} dados={Dadosnoti}  />
                      ) : ''}


                      { open2 === "notificaaudio" && Dadosnoti.tipochamada === 'encerrou' ? (
                            <ChamadaEncerradaDialog  fecharmodal={fecharmodal} dados={Dadosnoti}  />
                      ) : ''}




                      { open2 === "notificavideo" && Dadosnoti.tipochamada === 'recebida'? (
                            <NotificaVideo socket={socket} fecharmodal={fecharmodal} dados={Dadosnoti}/>
                      ) : ''}

                      { open2 === "notificavideo" && Dadosnoti.tipochamada === 'recusada' ? (
                          <ChamadaRecusadaDialog   fecharmodal={fecharmodal} dados={Dadosnoti}  />
                      ) : ''}

                      { open2 === "notificavideo" && Dadosnoti.tipochamada === 'encerrou' ? (
                          <ChamadaEncerradaDialog   fecharmodal={fecharmodal} dados={Dadosnoti}  />
                      ) : ''}

                  </Dialog> 
                
                   
        
      </>
    )


  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;
  let contributionLayout: 'horizontal' | 'mini' | 'vertical' = 'vertical';

  if (isNavHorizontal) {
    contributionLayout = 'horizontal';
  } else if (isNavMini) {
    contributionLayout = 'mini';
  }

  const contributionTopbar = (
    <ContributionTopbar layout={contributionLayout} onHeightChange={setContributionOffset} />
  );


  if (isNavHorizontal) {
    return (
      <>
          {tipo}
          {dialogChamada}
        {contributionTopbar}
        <Header onOpenNav={handleOpen} contributionOffset={contributionOffset} />

        {isDesktop ? <NavHorizontal contributionOffset={contributionOffset} /> : renderNavVertical}

        <Main contributionOffset={contributionOffset}>
          <Outlet />
        </Main>
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
          {tipo}
          {dialogChamada}
        {contributionTopbar}
        <Header onOpenNav={handleOpen} contributionOffset={contributionOffset} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main contributionOffset={contributionOffset}>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
        {tipo}
        {dialogChamada}
      {contributionTopbar}
      <Header onOpenNav={handleOpen} contributionOffset={contributionOffset} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main contributionOffset={contributionOffset}>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
